import React, { useState }  from 'react'
import axios from 'axios'
import { MdArrowLeft, MdArrowRight } from "react-icons/md"
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`

export default function BookInterviewUIFriendly() {
  const [schedule, setSchedule] = useState([])
  const [schedule1, setSchedule1] = useState([])
  const [schedule2, setSchedule2] = useState([])
  const [calendar, setCalendar] = useState('schedule1')
  const [calendarData, setCalendarData] = useState()
  const [scheduleDisplay,setScheduleDisplay] = useState(false)
  const [msg, setMsg] = useState('')
  const [err, setErr] = useState('')
  const [reservation_data, setReservation_data] = useState([])
  const startDaysOfTheWeekList = ['Sun','Mon','Tue','Wed','Thu','Fri', 'Sat']
  function join(date, options, separator) {
    function format(option) {
      let formatter = new Intl.DateTimeFormat('en', option)
      return formatter.format(date)
    }
    return options.map(format).join(separator)
  }
  function getDaysInMonthUTC(m, y) {
    var date = new Date(Date.UTC(y, m, 1))
    var startDaysOfTheWeek = ''
    var d = []
    while (date.getUTCMonth() === m) {
      if(startDaysOfTheWeek==''){
        startDaysOfTheWeek =new Date(date).toString().slice(0,3)
        if(startDaysOfTheWeek=='Mon'){
          d.push(join(new Date(new Date(Date.UTC(y, m, 0))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
        }else if(startDaysOfTheWeek=='Tue'){
          d.push(join(new Date(new Date(Date.UTC(y, m, -1))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, 0))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
        }else if(startDaysOfTheWeek=='Wed'){
          d.push(join(new Date(new Date(Date.UTC(y, m, -2))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -1))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, 0))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
        }else if(startDaysOfTheWeek=='Thu'){
          d.push(join(new Date(new Date(Date.UTC(y, m, -3))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -2))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -1))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, 0))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
        }else if(startDaysOfTheWeek=='Fri'){
          d.push(join(new Date(new Date(Date.UTC(y, m, -4))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -3))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -2))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -1))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, 0))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
        }else if(startDaysOfTheWeek=='Sat'){
          d.push(join(new Date(new Date(Date.UTC(y, m, -5))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -4))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -3))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -2))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -1))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, 0))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
        }
      }
      d.push(join(new Date(date), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
      date.setUTCDate(date.getUTCDate() + 1)
    }
    return d
  }
  const today = join(new Date(), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-')
  const today_plus_3days_timestamp = new Date().getTime() +(1000*60*60*24*3)
  const today_plus_3days_format = join(new Date(today_plus_3days_timestamp), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-')
  console.log('today+3',today_plus_3days_format)
  const [date, setDate] = useState(today_plus_3days_format)
  const [time, setTime] = useState('')
  const today_plus_33days_timestamp = new Date().getTime()+(1000*60*60*24*32)
  const today_plus_33days_format = join(new Date(today_plus_33days_timestamp), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-')
  const onClick2CreateScheduleMenu = async()=>{
    setMsg('')
    setErr('')
    setDate('')
    setTime('')
    setCalendar('schedule1')
    let mtg_timesheet={}
    for(let i1=3;i1<33;i1++){
      const timestamp = new Date(`${today.slice(5,7)}/${today.slice(8,10)}/${today.slice(0,4)}`).getTime()+(1000*60*60*24*i1)
      const format = join(new Date(timestamp), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-')
      mtg_timesheet[`${format}`] = [{"10.00-11.00":"F"},{"13.00-14.00":"F"},{"14.00-15.00":"F"}]
    } 
    setCalendarData(getDaysInMonthUTC(join(new Date(), [{month: 'numeric'}])-1,join(new Date(), [{year: 'numeric'}])))
    setSchedule1(getDaysInMonthUTC(join(new Date(), [{month: 'numeric'}])-1,join(new Date(), [{year: 'numeric'}])))
    setSchedule2(getDaysInMonthUTC(Number(join(new Date(), [{month: 'numeric'}])),join(new Date(), [{year: 'numeric'}])))
    let reservation_data2 = ''
    try {
      const { data: res } = await axios.get(`${APIURL}/basic/interview-mtg2`)
      setReservation_data(res.info)
      reservation_data2 = res.info
    } catch (err) {
      console.log(err)
    }
    for(let i2 = 0; i2<Object.keys(reservation_data2).length;i2++){
      let dataset = [{"10.00-11.00":"F"},{"13.00-14.00":"F"},{"14.00-15.00":"F"}]
      for(let i3 = 0; i3<Object.values(reservation_data2)[i2].length;i3++){
        if(Object.keys(Object.values(reservation_data2)[i2][i3])=="10.00-11.00"){
          dataset[0]={"10.00-11.00":"T"}
      }else if(Object.keys(Object.values(reservation_data2)[i2][i3])=="13.00-14.00"){
        dataset[1]={"13.00-14.00":"T"}
      }else{
        dataset[2]={"14.00-15.00":"T"}
      }
    }
    mtg_timesheet[Object.keys(reservation_data2)[i2]]=dataset
    }
    setSchedule(mtg_timesheet)
    setScheduleDisplay(true)
  } 
  const onClick2Date = (x) => { 
    if(x.slice(5,7)==calendarData[15].slice(5,7)&&new Date(x).getTime()>=new Date(today_plus_3days_format).getTime()&&new Date(x).getTime()<=new Date(today_plus_33days_format).getTime()){
      setDate(x)
    }
  } 
  const onClick2SwicthToSchedule1 =()=>{
    setCalendar('schedule1')
    setCalendarData(schedule1)
  }
  const onClick2SwicthToSchedule2 =()=>{
    setCalendar('schedule2')
    setCalendarData(schedule2)
  }
  const onClick2Submit = async()=>{
    setErr('')
    setMsg('')
    const date_timestamp = new Date(`${date.slice(5,7)}/${date.slice(8,10)}/${date.slice(0,4)}`).getTime()
    if(date==''){
      setErr('Please select date.')
    }else if(time==''){
      setErr('Please select time.')
    }else if(date_timestamp<today_plus_3days_timestamp){
      setErr(`You can book from ${new Date(today_plus_3days_timestamp).toLocaleDateString("en-US", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'})}.`)
    }else{
      const a1 = Object.keys(reservation_data).filter(x=>x==date)
      if(a1.length==1){
        let format = schedule[`${date}`]
        let a2 = {}
        a2[`${time}`]="T"
        format[format.findIndex((x) => Object.keys(x) == time)]=a2
        reservation_data[`${date}`]=format.filter((x)=>Object.values(x)!="F")
      }else{
        let a1 = []
        let a2 ={}
        a2[`${time}`] = "T"
        a1.push(a2)
        reservation_data[`${date}`]=a1
      }
      function timeConverter(x){
        return new Date(`${x.slice(5,7)}/${x.slice(8,10)}/${x.slice(0,4)}`).getTime()
      }
      const reservation_data2 = Object.fromEntries(Object.entries(reservation_data).sort((a, b) => {
        return timeConverter(a[0]) - timeConverter(b[0])
        }))
      try {
        const { data: res } = await axios.post(`${APIURL}/basic/interview-mtg2`,{'reservation_data':reservation_data2})
      } catch (err) {
        console.log(err)
      }
      console.log(reservation_data2)
      setMsg(`You are successfully submitted. Your interview is on ${new Date(date_timestamp).toLocaleDateString("en-US", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })} at ${time.toString().slice(0,5)}.`)
        setScheduleDisplay(false)
      }
  }
  return (
      <div>
      <button className='text-xs primary-btn w-fit mb-1' onClick={onClick2CreateScheduleMenu} disabled={scheduleDisplay}>Set interview time</button>
      {scheduleDisplay?<div className='w-fit mt-4 text-xs flex flex-col'><div className='w-fit'>
      <div className='flex'>
      <div className='flex flex-col mr-4'>
      <div className='flex justify-between mb-1'><MdArrowLeft className={`${calendar=='schedule1'?'invisible':''} mt-auto mb-auto`} onClick={()=>onClick2SwicthToSchedule1()}/><span className='mt-auto mb-auto'>{calendarData[15].slice(5,7)}</span><MdArrowRight  className={`${calendar=='schedule2'?'invisible':''} mt-auto mb-auto`} onClick={()=>onClick2SwicthToSchedule2()}/></div>
      <div className='flex'>{startDaysOfTheWeekList.map(x=><div className='text-center text-[8px] w-[28px]'>{x}</div>)}</div>
      {/* diable<br/>
      1 if it is not in this months<br/>
      2 if it is not in term<br/> */}
      <div className='grid grid-cols-7'>
      {calendarData.map((x)=><div className='text-center text-[8px] w-[28px]'><span className={`${x.slice(5,7)!=calendarData[15].slice(5,7)?'text-gray-200':''} 
      ${today_plus_3days_format.slice(5,7) == x.slice(5,7) && Number(today_plus_3days_format.slice(8,12))<= Number(x.slice(8,12))?'hover:rounded-[100px] hover:bg-gray-100':'text-gray-400'}
      ${today_plus_3days_format.slice(5,7) == x.slice(5,7) && Number(today_plus_3days_format.slice(8,12))<= Number(x.slice(8,12))?'text-gray-900 hover:rounded-[100px] hover:bg-gray-100':''}</>}
      ${today_plus_3days_format.slice(5,7) == x.slice(5,7) && Number(today_plus_3days_format.slice(8,12))> Number(x.slice(8,12))?'text-gray-400':''}</>}
      ${today_plus_33days_format.slice(5,7) == x.slice(5,7)&& Number(today_plus_33days_format.slice(8,12))>= Number(x.slice(8,12))?'text-gray-900 hover:rounded-[100px] hover:bg-gray-100':''} 
      ${today_plus_33days_format.slice(5,7) != x.slice(5,7) && Number(today_plus_33days_format.slice(8,12))< Number(x.slice(8,12))?'text-gray-400':''}
      ${date!=x ?'':'font-bold rounded-[100px] bg-gray-100'} p-1 cursor-default`} onClick={()=>onClick2Date(x)}
      >{x.slice(x.length-2,x.length)}</span></div>)}
      </div>  
      </div>
      <div className='flex flex-col'>
      <div className='mt-[24px]'>
      {date!=''?<>
      {schedule[date].map(x2=><>{Object.values(x2)!='T'?<div id={Object.keys(x2)} className={`text-[8px] border border-gray-200 w-[68px] ml-auto mr-auto rounded-sm text-gray-300 pl-1 pr-1 mb-1 mr-1 cursor-default hover:bg-gray-100 ${time!=Object.keys(x2)[0]?'':'font-bold text-gray-900 bg-gray-100'}`} name={date} value='T' onClick={()=>setTime(Object.keys(x2)[0])}> {Object.keys(x2)}</div>:''}</>)}</>:''}
      </div>
      </div>
      </div>
      </div>
      <p className='mt-4 mb-1'>Your meeting time:</p>
      <div className='mr-1'>{date} {time}</div>
      {err!='' ? <span className='text-xs text-red-700'>{err}</span>:''}
      <div className='flex mt-4'>
      <div className='primary-btn text-xs w-fit mt-1 mr-1' onClick={()=>setScheduleDisplay(!scheduleDisplay)}>Cancel</div>
      <button className='primary-btn text-xs w-fit mt-1' onClick={onClick2Submit}>Submit</button>
      </div>
      </div>:''}<br/>
      {msg!='' ? <>
      <span className='text-xs'>{msg}</span><br/>
      </>:''}
      </div>
  )
}